import { useSelector } from 'react-redux';

import { productFeatureDisabled } from 'dashboard/lib/productFeature';
import { ProductFeatureName } from 'dashboard/models/organization';
import { OrganizationPlanKey } from 'dashboard/models/organization-plan';
import { RootState } from 'dashboard/redux/store';
import useCurrentEnvironmentType from 'lib/hooks/useCurrentEnvironmentType';
import useFeatureFlag from 'lib/hooks/useFeatureFlag';
import { ApiModel } from 'lib/interfaces/api';

const usePlanRequirements = (
  requiredProductFeatures: ProductFeatureName[],
  builderRequiresOrderForm: boolean,
) => {
  const { organization, currentOrganizationPlan } = useSelector((state: RootState) => ({
    organization: state.organization.organization,
    currentOrganizationPlan: state.organization.currentOrganizationPlan,
  }));

  const orgRequiresUpdatedOrderForm = useFeatureFlag(
    'dashboard:requires-updated-essential-order-form',
  );
  const { type: environmentType } = useCurrentEnvironmentType();

  const requiresPlanUpgrade = requiredProductFeatures.some((productFeature) =>
    productFeatureDisabled(organization, productFeature, environmentType),
  );

  const requiresAddOn =
    !requiresPlanUpgrade &&
    environmentType === ApiModel.EnvironmentProduction &&
    builderRequiresOrderForm &&
    orgRequiresUpdatedOrderForm &&
    currentOrganizationPlan.attributes.key === OrganizationPlanKey.Essential;

  return { requiresPlanUpgrade, requiresAddOn };
};

export default usePlanRequirements;
